export default "__VITE_PUBLIC_ASSET__07768985__"